<div class="form-group" ngModelGroup="{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div class="w-100">
        <ng-template #customItemTemplate let-model="item" let-index="index">
            <div class="d-flex align-items-center mt-1 mb-1">
                <div class="truncate">
                    <div class="truncate text-light">
                        <span class="truncate-name">
                            {{ model | truncate: 33 }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-template>
        <div
            class="tags-input-container form-control d-flex flex-wrap"
            [ngClass]="{ 'ng-invalid': formService.isSubmitted && formField.isRequired && !formField.value }">
            @if (selectedEmails.length) {
                <div class="tag truncate">
                    <span class="tag-text truncate">{{ selectedEmails[0] }}</span>
                    <sb-inline-svg
                        class="icon icon-close"
                        role="button"
                        [attr.aria-label]="'Remove email' | translate"
                        (click)="removeEmail()"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                    </sb-inline-svg>
                </div>
            } @else {
                <input
                    name="formField{{ formField.id }}"
                    id="form-element-{{ formField.id }}"
                    autocomplete="off"
                    class="typeahead-input"
                    appFocus
                    [appAutoFocus]="formField.isNeedToFocus"
                    [placeholder]="formField.placeholder || 'Select or type email'"
                    [typeaheadMinLength]="0"
                    [typeaheadSelectFirstItem]="false"
                    [typeaheadIsFirstItemActive]="false"
                    [typeahead]="allEmails"
                    [typeaheadScrollable]="true"
                    [typeaheadOptionsInScrollableView]="4"
                    [typeaheadItemTemplate]="customItemTemplate"
                    [(ngModel)]="selectedEmail"
                    (typeaheadOnSelect)="addEmail($event)"
                    (keydown)="keyDownHandler($event)"
                    (blur)="checkAndAddNewEmail()"
                    maxlength="1000" />
            }
        </div>
        @if (formService.isSubmitted && !formField.value && formField.isRequired) {
            <div class="text-danger">
                @if (selectedEmail) {
                    <span translate> Please enter a valid email address </span>
                } @else {
                    <span translate> Please fill this field </span>
                }
            </div>
        }
    </div>
</div>
